import { useTranslation } from "react-i18next";
import { ORDER_DIRECTION } from "../../constants";
type DirectionType = (typeof ORDER_DIRECTION)[keyof typeof ORDER_DIRECTION]; // 从 ORDER_DIRECTION 获取类型

const directionStyles = {
    [ORDER_DIRECTION.buy]: {
        bgColor: "bg-AlphaGreen dark:bg-DarkAlphaGreen",
        textColor: "text-text_buy",
        label: "buy",
    },
    [ORDER_DIRECTION.swap]: {
        bgColor: "bg-AlphaBlue dark:bg-DarkAlphaBlue",
        textColor: "text-text_link",
        label: "swap",
    },
    [ORDER_DIRECTION.sell]: {
        bgColor: "bg-AlphaRed dark:bg-DarkAlphaRed",
        textColor: "text-text_sell",
        label: "sell",
    },
};

interface TagDirectionProps {
    type: DirectionType;
}

export default function TagDirection({ type }: TagDirectionProps) {
    const { t } = useTranslation();
    const direction = directionStyles[type];

    if (!direction) return null;

    return (
        <div
            className={`flex items-center h-[16px] px-[4px]  mr-[2px] rounded-[4px] ${direction.bgColor}`}
        >
            <span
                className={`text-direction1 font-Regular ${direction.textColor}`}
            >
                {t(direction.label)}
            </span>
        </div>
    );
}
